
import overrides from "./precheckOverrides.json"

export const getThresholdConfig = (hme_org_code, hme_location_code) => {

    const no_overrides = {};
    let location_override = undefined;
    let org_override = undefined;

    for (const override of overrides ){

        if ( "hme_org_code" in override && override["hme_org_code"] === hme_org_code ) {
            org_override = override["overrides"];
        }

        if ( "hme_location_code" in override && override["hme_location_code"] === hme_location_code ) {
            location_override = override["overrides"];
        }
    }

    if ( location_override !== undefined ) {
        return location_override;
    }

    if (org_override !== undefined) {
        return org_override
    }

    return no_overrides;
}